<rt-select
  [formControl]="input.control"
  [options]="regionOptions"
  [hasSearch]="true"
  [placeholder]="selectPlaceholder"
>
</rt-select>
